<template>
  <div class="h-100">
    <div class="loader-cont" v-dxloader="isLoader"></div>
    <div class="row h-100" v-show="!isLoader">
      <div class="content-wrapper-before gradient-45deg-indigo-purple"></div>
      <div class="breadcrumbs-dark pb-0 pt-4" id="breadcrumbs-wrapper">
        <!-- Search for small screen-->
        <div class="container">
          <div class="row">
            <div class="col s10 m6 l6 alignLeft">
              <h5 class="card-title alignLeft white-text">Audits</h5>
            </div>
          </div>
        </div>
      </div>
      <div class="col s12 p-0" style="height:calc(100% - 45px)">
        <div class="container p-0 h-100">
          <div class="section p-0 h-100">
            <div class="row m-0 h-100">
              <div class="col s12 m12 l12 p-0 h-100">
                <div id="responsive-table" class="card card card-default scrollspy mb-0 h-100">
                  <div class="card-content h-100" style="overflow:auto">
                    <div class="row filter-cls">
                      <div class="search-input col s5 m5 l5">
                        <div class="sidebar-search animate fadeUp">
                          <div class="search-area">
                            <i class="material-icons mr-2 search-icon">search</i>
                            <i class="material-icons mr-2 close-icon" @click="reset(1,$event)">close</i>
                            <input
                              type="text"
                              autocomplete="off"
                              v-model="searchText"
                              placeholder="Search by booking id"
                              class="app-filter"
                              id="chat_filter"
                            />
                          </div>
                        </div>
                      </div>
                      <div class="col s3 m3 l3">
                        <div class="input-field">
                          <i class="material-icons mr-2 close-icon" @click="reset(2,$event)">close</i>
                          <input name="date" class="datepicker" id="datepicker" type="text" />
                          <label for="datepicker" class>Filter by date</label>
                        </div>
                      </div>
                      <div class="col s4 m4 l4">
                        <div class="input-field">
                          <i class="material-icons mr-2 close-icon" @click="reset(3,$event)">close</i>
                          <input
                            autocomplete="off"
                            type="text"
                            id="autocomplete-input"
                            class="autocomplete"
                          />
                          <label for="autocomplete-input">Filter by status</label>
                        </div>
                      </div>
                    </div>
                    <div class="row audit-block" style="height: calc(100% - 80px); overflow-y: auto">
                      <div class="col s12 l12 m12 block-overflow" style="height:100%">
                        <div
                          class="card-view row"
                          v-for="(audit) in auditList.results"
                          :key="audit.audit_no"
                        >
                          <div class="col s9 m9 l9 p-0">
                            <div class="card-view-content pointer" @click="selectAudit(audit)">
                              <div class="indicator"></div>
                              <div class="text-content">
                                <div class="label-status">
                                  <span class="classtag">{{audit.uid}}</span>
                                  <span class="prioritytag">{{audit.service}}</span>
                                </div>
                                <div class="title-cd" v-if="audit.vendor">
                                  <span>#{{audit.vendor ? audit.vendor.rep_id : ""}}</span>
                                  {{audit.vendor ? audit.vendor.first_name : ""}}
                                </div>
                                <div class="inn-cont">
                                  <div class="owner">{{audit.user ? audit.user.first_name : "-"}}</div>
                                  <div class="created_at">{{audit.created_at | relativeTime}}</div>
                                </div>
                              </div>
                            </div>
                            <div>
                              <span
                                v-if="audit.dates"
                                class="statustag"
                              >{{audit.dates ? (audit.dates.status ? audit.dates.status.name : "") : ""}}</span>
                            </div>
                          </div>
                          <div class="col s3 m3 l3">
                            <div class="assignee-block col l6">
                              <div class="assignee-title">Assignee</div>
                              <div class="assignee" v-if="audit.vendor">
                                <b>{{audit.vendor ? audit.vendor.first_name : ""}}({{audit.vendor ? audit.vendor.rep_id : ""}})</b>
                              </div>
                              <div class="assignee" v-if="!audit.vendor">
                                No one
                                <!-- <a @click="assignMySelf(audit)" class="pointer">assign yourself</a> -->
                              </div>
                              <!-- <i
                                v-if="!audit.vendor && isAssigneeShow(audit)"
                                @click="openAssignees($event,audit)"
                                class="material-icons a-settings"
                              >settings</i>-->
                            </div>
                            <div class="assignee-settings col l6">
                              <popper trigger="click" :options="{placement: 'bottom'}">
                                <div class="assignees-list popper">
                                  <div class="input-search-box search-input">
                                    <div class="search-area">
                                      <i class="material-icons mr-2 search-icon">search</i>
                                      <input
                                        type="text"
                                        placeholder="Search assignees"
                                        id="assignee_filter"
                                        class="app-filter assignee_filter"
                                        v-model.trim="assigneeSearch"
                                        @click="searchAssignee"
                                      />
                                    </div>
                                  </div>
                                  <div class="list-opts">
                                    <div class="loader" v-if="assigneeLoader">
                                      <svg
                                        version="1.1"
                                        id="L9"
                                        xmlns="http://www.w3.org/2000/svg"
                                        xmlns:xlink="http://www.w3.org/1999/xlink"
                                        x="0px"
                                        y="0px"
                                        viewBox="0 0 100 100"
                                        enable-background="new 0 0 0 0"
                                        xml:space="preserve"
                                      >
                                        <path
                                          fill="#cdefd0"
                                          d="M73,50c0-12.7-10.3-23-23-23S27,37.3,27,50 M30.9,50c0-10.5,8.5-19.1,19.1-19.1S69.1,39.5,69.1,50"
                                        >
                                          <animateTransform
                                            attributeName="transform"
                                            attributeType="XML"
                                            type="rotate"
                                            dur="1s"
                                            from="0 50 50"
                                            to="360 50 50"
                                            repeatCount="indefinite"
                                          />
                                        </path>
                                      </svg>
                                    </div>
                                    <div class="assingee-block" v-if="!assigneeLoader">
                                      <div
                                        v-if="assigneeList.length==0"
                                        class="assignees-list-items"
                                      >
                                        <div class="uname center-align">No vendors found</div>
                                      </div>
                                      <div
                                        class="assignees-list-items"
                                        @click="selectAssignee(assignee)"
                                        v-for="(assignee,index) in assigneeList"
                                        :key="index"
                                      >
                                        <div class="usr-img">{{assignee.vendor.short_name}}</div>
                                        <div class="uname">{{assignee.vendor.first_name}}</div>
                                        <div
                                          class="fullname"
                                          v-if="assignee.vendor"
                                        >{{assignee.vendor ? (assignee.vendor.rep_id + ",") : ""}}</div>
                                        <div class="distance">{{assignee.distance | number}} km away</div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <a
                                  slot="reference"
                                  class="top"
                                  v-if="!audit.vendor && isAssigneeShow(audit)"
                                  @click="openAssignees($event,audit)"
                                >
                                  <i class="material-icons a-settings">settings</i>
                                </a>
                              </popper>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Popper from "vue-popperjs";
import "vue-popperjs/dist/vue-popper.css";

export default {
  data() {
    return {
      auditList: {
        results: [],
        count: 0,
        previous: null,
        next: null
      },
      assigneeList: [],
      vendorList: [],
      currAudit: {},
      searchText: "",
      filters: {
        date: "",
        status: ""
      },
      isLoader: true,
      assigneeLoader: false,
      statusList: [
        "Payment Failed",
        "Audit Booked",
        "Audit Started",
        "Audit Completed",
        "Audit Cancelled",
        "Vendor Declined"
      ],
      assigneeSearch:''
    };
  },
  components: {
    popper: Popper
  },
  async created() {
    var thisObj = this;
    setTimeout(() => {
      // Vue.scrollBottom("", () => {
      //   if (thisObj.auditList.next) {
      //     thisObj.listAudits(thisObj.auditList.next, true);
      //   }
      // });
      $(".block-overflow").on("scroll", async e => {
        var docheight = e.target.scrollHeight - e.target.clientHeight;
        var scrollTop = e.target.scrollTop;
        var pctScrolled = Math.floor((scrollTop / docheight) * 100);
        if (thisObj.auditList.next) {
          if (pctScrolled >= 90 && this.isLazyLoading == true) {
            this.isLazyLoading = false;
            await thisObj.listAudits(thisObj.auditList.next, true);
            this.isLazyLoading = true;
          }
        }
      });

      let opts = {
        onSelect: e => {
          this.filters.date = e;
          this.searchFilter(this.filters);
          $("i.close-icon")
            .eq(1)
            .show();
          M.updateTextFields();
        },
        autoClose: true
      };

      window.instance = M.Datepicker.init(
        document.querySelectorAll(".datepicker"),
        opts
      );
      setTimeout(() => {
        $(".datepicker").on("focusin", e => {
          if (instance[0] && !instance[0].isOpen) {
            instance[0].open();
          }
        });
      }, 100);
    this.onInitFunc();
    }, 500);
    setTimeout(() => {
      try {
        notificationHub.$on("received", payload => {
          thisObj.onInitFunc();
        });
      } catch (error) {}
    }, 100);
  },
  methods: {
    onInitFunc() {
      this.listAudits();
      this.listAllStatus();
    },
    listAudits(url = Constants.default.APIURL.Audits, status = false) {
      return new Promise(resolve => {
        ajax.get(
          url,
          res => {
            let temp = this.auditList;
            if (status) {
              let temp = this.auditList.results;
              this.auditList = {
                count: res.data.count,
                previous: res.data.previous,
                next: res.data.next
              };
              this.auditList.results = temp.concat(res.data.results);
            } else {
              this.auditList = res.data;
            }

            setTimeout(() => {
              this.isLoader = false;
              if (this.auditList.results.length == 0) {
                Vue.showNoDataBlock(".audit-block");
              } else {
                Vue.hideNoDataBlock(".audit-block");
              }
            }, 500);
            resolve(true);
          },
          err => {
            this.isLoader = false;
            resolve(false);
          }
        );
      });
    },
    async searchFilter(filter) {
      let queryStr = "?q=" + (this.searchText || "");
      queryStr +=
        "&dates__date=" +
        (filter.date ? new Date(filter.date + "z").toJSON().split("T")[0] : "");
      queryStr += "&dates__status__name=" + (filter.status || "");
      let url = Constants.default.APIURL.Audits + queryStr;
      await this.listAudits(url);
    },
    openAssignees(ev, audit) {
      this.currAudit = audit;
      this.listAssignees(
        Constants.default.APIURL.RelatedVendors + this.currAudit.uid
      );
    },
    selectAudit(audit) {
      this.$router.push({ path: "/app/audits-detail/" + audit.uid });
    },
    listAssignees(url) {
      this.assigneeLoader = true;
      return new Promise(resolve => {
        ajax.get(
          url,
          res => {
            this.assigneeList = res.data;
            this.assigneeLoader = false;
            resolve(true);
          },
          err => {
            this.assigneeLoader = false;
            resolve(false);
          }
        );
      });
    },
    listAllStatus() {
      return new Promise(resolve => {
        let data = {};
        this.statusList.forEach(val => {
          data[val] = null;
        });
        let opts = {
          data: data,
          minLength: 0,
          onAutocomplete: text => {
            let temp = text.split(" ")[text.split(" ").length - 1];
            let item = this.statusList.find(val => {
              return val == text;
            });
            this.filters.status = item;
            this.searchFilter(this.filters);
            $("i.close-icon")
              .eq(2)
              .show();
            M.updateTextFields();
          }
        };
        $(".autocomplete").on("keyup", e => {
          if (!e.target.value) {
            this.filters.vendor = "";
            $("i.close-icon")
              .eq(2)
              .hide();
            this.searchFilter(this.filters);
          }
        });
        setTimeout(() => {
          window.autocompleteInstance = M.Autocomplete.init(
            document.querySelectorAll(".autocomplete"),
            opts
          );
          setTimeout(() => {
            $(".autocomplete").on("focusin", e => {
              if (autocompleteInstance[0] && !autocompleteInstance[0].isOpen) {
                setTimeout(() => {
                  autocompleteInstance[0].open();
                }, 100);
              }
            });
          }, 100);
        }, 300);
        resolve(true);
      });
    },
    selectAssignee(assignee) {
      let query = {
        vendor: assignee.vendor.id
      };
      ajax.patch(
        Constants.default.APIURL.AssignVendor + this.currAudit.uid,
        query,
        res => {
          Vue.toast("Audit has been assigned successfully.");
          this.listAudits();
        },
        err => {
          Vue.toast("", err);
        }
      );
    },
    reset(type, ev) {
      if (type == 1) {
        this.searchText = "";
      } else if (type == 2) {
        this.filters.date = "";
      } else {
        this.filters.vendor = "";
      }
      $(ev.target)
        .closest("div")
        .children()
        .each((key, dom) => {
          if (dom.tagName == "INPUT") {
            dom.value = "";
          }
        });
      setTimeout(() => {
        $(ev.target).hide();
        M.updateTextFields();
      }, 200);
      this.searchFilter(this.filters);
    },
    isAssigneeShow(item) {
      let isCancel =
        item.dates.status.code == "audit_started" ||
        item.dates.status.code == "audit_completed" ||
        item.dates.status.code == "audit_cancelled" ||
        item.dates.status.code == "payment_failed" ||
        item.dates.status.code == "admin_audit_cancelled";
      return !isCancel;
    },
    searchAssignee(){
      console.log('search',this.assigneeSearch)
    }
  },
  watch: {
    searchText(text) {
      this.searchText = text;
      if (text) {
        $("i.close-icon")
          .eq(0)
          .show();
      } else {
        $("i.close-icon")
          .eq(0)
          .hide();
      }
      this.searchFilter(this.filters);
    }
  }
};
</script>

<style lang="scss" scoped>
.center-align {
  text-align: center;
  width: 100%;
}
.assignee-block {
  position: relative;
  text-align: left;
  top: 20px;
  .assignee-title {
    font-weight: 500;
  }
  .assignee {
    color: #183247;
    font-size: 14px;
  }
}
.assignee-settings {
  position: relative;
  top: 20px;
  a {
    color: #183247;
    i {
      cursor: pointer;
      font-size: 18px;
    }
  }
}

.assignees-list {
  min-width: 300px;
  // overflow: hidden auto;
  padding: 5px;
  box-shadow: rgb(58, 58, 58) 0 0 1px 0;
  .list-opts {
    min-height: 100px;
    .loader {
      svg {
        width: 100px;
      }
    }
  }
  .input-search-box {
    padding: 0 0 10px;
    position: sticky;
    top: 0;
    background: white;
  }
  .assignees-list-items {
    display: flex;
    cursor: pointer;
    align-items: center;
    justify-content: flex-start;
    padding: 5px 10px 0px 10px;
    div {
      margin: 5px;
      padding: 0px;
    }
    .usr-img {
      width: 30px;
      height: 30px;
      border-radius: 5px;
      background: #efe7e7;
    }

    .uname {
      font-weight: 600;
    }
  }
}

.filter-cls {
  .search-input {
    i.close-icon {
      display: none;
      position: absolute;
      right: 10px;
      cursor: pointer;
      font-size: 18px;
      top: 15px;
    }
  }
  .input-field {
    i.close-icon {
      position: absolute;
      display: none;
      cursor: pointer;
      right: 0;
      font-size: 18px;
      top: 15px;
    }
  }
}

.show-assignee {
  max-height: 400px;
  opacity: 1;
  margin-bottom: 100px;
}

.name-cls {
  display: inline-block;
  white-space: nowrap;
  max-width: 150px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.desp {
  padding: 0 10px;
}

.filter-cls {
  .input-field {
    margin-top: 10px;
  }
}

.search-input {
  .sidebar-search {
    display: -webkit-box;
    display: -webkit-flex;
    display: -moz-box;
    display: -ms-flexbox;
    display: flex;
    padding: 1rem 0;
    -webkit-box-pack: justify;
    -webkit-justify-content: space-between;
    -moz-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -moz-box-align: center;
    -ms-flex-align: center;
    align-items: center;
  }
  .search-area {
    display: -webkit-box;
    display: -webkit-flex;
    display: -moz-box;
    display: -ms-flexbox;
    display: flex;
    width: -webkit-calc(100% - 0rem);
    width: -moz-calc(100% - 0rem);
    width: calc(100% - 0rem);
    -webkit-box-align: center;
    -webkit-align-items: center;
    -moz-box-align: center;
    -ms-flex-align: center;
    align-items: center;
  }
  i {
    font-size: 1.45rem;
    height: 41px;
    margin-right: 0 !important;
    padding: 0.75rem 0.25rem 0.35rem 0.75rem;
    color: #9e9e9e;
    border-radius: 5px;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
    background-color: #eceff1;
    position: inherit;
  }
  .app-filter {
    height: 35px;
    margin-bottom: 0;
    padding: 0.2rem;
    color: #9e9e9e;
    border: none;
    border-radius: 5px;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    background-color: #eceff1;
    -webkit-box-flex: 1;
    -webkit-flex: 1;
    -moz-box-flex: 1;
    -ms-flex: 1;
    flex: 1;
    border-bottom: 0 !important;
    box-shadow: none !important;
  }
}

.card-view:hover .indicator {
  height: 100%;
  top: 0 !important;
  opacity: 1;
}

.card-view {
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(220, 220, 220, 0.151);
  margin: 15px 0;
  padding: 20px;
  position: relative;
  border-radius: 3px;
  .indicator {
    position: absolute;
    height: 0;
    width: 2px;
    background: #ef0000;
    left: -1px;
    top: 50%;
    opacity: 0;
    border-radius: 5px;
    transition: 0.4s ease-in-out;
  }
  .card-view-content {
    text-align: left;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    float: left;
    .owner {
      display: inline-block;
      font-weight: 500;
      padding-right: 6px;
      font-size: 14px;
    }
    .created_at {
      display: inline-block;
      color: #9e9e9e;
      font-size: 13px;
      &::before {
        content: "";
        display: inline-block;
        width: 4px;
        height: 4px;
        background: #a2aab4;
        border-radius: 100%;
        margin-right: 7px;
      }
    }

    .text-content {
      line-height: 1.8;
      .label-status {
        display: inline-block;
        margin-bottom: 3px;
      }
      span {
        &.classtag {
          font-size: 15px;
          font-weight: 500;
          display: block;
        }
        &.prioritytag {
          border: 1px solid gainsboro;
          padding: 1px 10px;
          border-radius: 5px;
          font-size: 13px;
        }
      }
    }
  }

  .statustag {
    font-size: 14px;
    position: relative;
    top: 20px;
    background: #ff5a5a;
    color: #fff;
    padding: 2px 8px;
    border-radius: 4px;
    font-weight: 500;
    &.inprogress {
      background: #0099ff;
      border-color: #0099ff;
    }
    &.completed {
      background: #3fa93a;
      border-color: #3fa93a;
    }
    &.failed {
      background: #e48b22;
      border-color: #e48b22;
    }
  }
}

.icon-clas {
  height: 9px;
  width: 9px;
  position: absolute;
  left: -15px;
  top: 9px;
  background: #9e9e9e;
  border-radius: 2px;
}

.icon-clas.q-cls {
  background: #ef0000;
}

.icon-clas.q-filtr {
  background: rgb(71, 131, 201);
}

.select-cards.select-cls.audit {
  position: relative;
}
.servicetag {
  border: 1px solid #82e3b2;
  padding: 1px 10px;
  border-radius: 5px;
  font-size: 13px;
  margin-left: 15px;
  background: #82e3b2;
  color: #261ba7;
  font-weight: 500;
}
.datepicker-date-display .date-text {
  font-size: 20px;
}
</style>

